import { render, staticRenderFns } from "./AllocationOutModal.vue?vue&type=template&id=99ad4b6e&scoped=true"
import script from "./AllocationOutModal.vue?vue&type=script&lang=js"
export * from "./AllocationOutModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ad4b6e",
  null
  
)

export default component.exports